import { Component, OnInit, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { SharedDataService } from "src/app/shared/services/sharedata.service";


@Component({
    selector: "app-sign-in-up-redirect",
    templateUrl: "./sign-in-up-redirect.component.html",
    styleUrls: ["./sign-in-up-redirect.component.scss"],
})
export class SignInUpRedirectComponent implements OnInit {
    featureTags = {};
    constructor(
        public dialogRef: MatDialogRef<SignInUpRedirectComponent>,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        private subscription: SubscriptionService,
        private sharedDataservice: SharedDataService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
      this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    }

    public close(): void {
      try {
        this.dialogRef.close();
      } catch (error) {
        console.log(error.message)
      }

    }

    public redirectTo(membershipPoduct = ''): void {
      try {

        let currentRoute = this.router.routerState?.snapshot?.url;

        if(this.dialogRef){
          this.dialogRef.close();
        }
        
        if (!!this.featureTags && this.featureTags['ftags_membership']) {
          if(membershipPoduct){
              this.sharedDataservice.setRedirectToMembership(true); 
          }else{
              this.sharedDataservice.setRedirectToMembership(false);
          }
        }

        if(!!this.featureTags && this.featureTags['sf_mobile_view_issue']){
          setTimeout(() => {
            this.router.navigate(["/sign-in"], {
              queryParams: { returnUrl: currentRoute },
            });  
          }, 200);
        }else{
          this.router.navigate(["/sign-in"], {
              queryParams: { returnUrl: currentRoute },
          });
        }
    
        this.subscription.setEmitCloseDialogueSubjectNext();

        return;
      } catch (error) {
        console.log(error.message)
      }

    }
}
